// extracted by mini-css-extract-plugin
export default {"container":"BinarySwitch_container__ZOWsS","selected":"BinarySwitch_selected__R64yH","notSelected":"BinarySwitch_notSelected__QSFSj"};